/** Cancels the shell's `<main>` padding: the studio is a flush two-pane layout (mockup `data-flush`). */
export const FLUSH = "-mx-4 -my-6 lg:-mx-8 lg:-my-8";

/** Heading id the studio focuses after a state change removes the control the user just pressed. */
export const STUDIO_TITLE_ID = "widget-studio-title";
